import { isValidDate } from '../utils';
export const date = (value) => isValidDate(value);
